import { render, staticRenderFns } from "./ProductFactorItems.vue?vue&type=template&id=42973ed0&"
import script from "./ProductFactorItems.vue?vue&type=script&lang=js&"
export * from "./ProductFactorItems.vue?vue&type=script&lang=js&"
import style0 from "./ProductFactorItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports